export default function DashRemainingIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#FFF1EB" />
      <path
        d="M16 16L11.25 19.5625C11.1724 19.6207 11.1094 19.6962 11.066 19.783C11.0226 19.8698 11 19.9655 11 20.0625V22.875C11 23.0408 11.0658 23.1997 11.1831 23.3169C11.3003 23.4342 11.4592 23.5 11.625 23.5H20.375C20.5408 23.5 20.6997 23.4342 20.8169 23.3169C20.9342 23.1997 21 23.0408 21 22.875V20.0905C21 19.9939 20.9776 19.8986 20.9345 19.8121C20.8915 19.7256 20.829 19.6502 20.7519 19.5919L16 16ZM16 16V19.1246M16 16L11.25 12.4375C11.1724 12.3793 11.1094 12.3038 11.066 12.217C11.0226 12.1302 11 12.0345 11 11.9375V9.125C11 8.95924 11.0658 8.80027 11.1831 8.68306C11.3003 8.56585 11.4592 8.5 11.625 8.5H20.375C20.5408 8.5 20.6997 8.56585 20.8169 8.68306C20.9342 8.80027 21 8.95924 21 9.125V11.9095C21 12.0061 20.9776 12.1014 20.9345 12.1879C20.8915 12.2744 20.829 12.3498 20.7519 12.4081L16 16ZM11.8329 12.8746H20.1346"
        stroke="#FE7235"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
